import type { Topic } from '../types/topic'
import type { APIOrderings } from '../types/api'
import type { ElementalTypeEnum } from '../types/elemental'
import { APIFetch, filterResponse, filterResponseBoolean } from '.'

export const getTopics = async (queries?: {
  order_dir?: 'asc' | 'desc'
  order_by?: APIOrderings
  search?: string
  size?: number
  elemental_type_id?: ElementalTypeEnum
  is_featured?: boolean
  type_ids?: number
}): Promise<null | Topic[]> => {
  let url = '/topics'

  const parsedQueries = Object.entries(queries || [])
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => [key, String(value)])

  if (!queries?.size)
    parsedQueries.push(['size', '100'])

  const query = new URLSearchParams(parsedQueries)
  url += `?${query.toString()}`

  return filterResponse(await APIFetch(url, {
    method: 'GET',
  }))
}

export const getTopic = async (topicIdOrName: string): Promise<null | Topic> => {
  return filterResponse(await APIFetch(`/topics/${topicIdOrName}`, {
    method: 'GET',
  }))
}

export const followTopic = async (userId: string, topicId: number): Promise<boolean> => {
  return filterResponseBoolean(await APIFetch(`/topics/${topicId}/follows`, {
    method: 'POST',
  }))
}

export const unfollowTopic = async (userId: string, topicId: number): Promise<boolean> => {
  return filterResponseBoolean(await APIFetch(`/topics/${topicId}/follows`, {
    method: 'DELETE',
  }))
}
